export function parsePredictionsLocation(location) {
  const params = new URLSearchParams(location.search);

  let sector = params.get('sector');
  const view = params.get('view');
  const impl = params.get('impl');
  const px = params.get('px');
  const pxid = params.get('pxid');

  if (!sector) {
    for (const [key, value] of params.entries()) {
      if (key === 'sector' || key === 'view' || key === 'impl' || key === 'px' || key === 'pxid') continue;
      if (value === '' && key) {
        sector = key;
        break;
      }
    }
  }

  return {
    sector,
    view,
    impl,
    px,
    pxid
  };
}

export function buildPredictionsSearch({ view, sector, impl, px, pxid }) {
  const params = new URLSearchParams();
  if (view) params.set('view', view);
  if (impl) params.set('impl', impl);
  if (sector) params.set('sector', sector);
  if (px) params.set('px', px);
  if (pxid) params.set('pxid', pxid);
  const s = params.toString();
  return s ? `?${s}` : '';
}
